// Shared visual spec for the Tip of the Day feature, per Elijah's approved design spec (2026-08-01).
// Match these exactly rather than introducing new color treatments — see Requirements.md in the vault.
export const COLORS = {
  primaryText: "#111827",
  secondaryText: "#6B7280",
  pageBackground: "#F7F7F7",
  cardBackground: "#FFFFFF",
  border: "#E5E7EB",
  link: "#2563EB",
  destructive: "#EF2B2D",
  modalBackdrop: "rgba(0, 0, 0, 0.55)",
  gold: "#F2B705",
};

// Tip-type colors
export const TYPE_META = {
  audio: { label: "Audio", color: "#7C4DFF", bg: "#F1EAFE" },
  text: { label: "Text", color: "#26A987", bg: "#E7FAF0" },
};

// Reaction colors — exact hex not specified for these, only "green/yellow/blue, very light backgrounds";
// kept consistent with what was already approved/built for the reaction cards.
export const REACTION_COLORS = {
  insightful: { color: "#2E7D32", bg: "#E8F5E9" },
  interesting: { color: "#F2B705", bg: "#FEF6E0" },
  helpful: { color: "#1976D2", bg: "#E3F2FD" },
};

export const modalBackdropSlotProps = {
  backdrop: { sx: { backgroundColor: COLORS.modalBackdrop } },
};
